export enum ERRORKEY {
    DashboardExists = 1801,
    CustomFieldInProgress = 200,
    InvalidDAX = 2001,
    InvalidColumn = 2002
}